import { useEffect, useState, Fragment, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import ErrorMessage from "components/form/ErrorMessage"
import SuccessMessage from "components/form/SuccessMessage"
import Button from 'components/form/Button';
import {
  FirstName,
  LastName,
  Gender,
  WebSiteLink,
  Nationality,
  Notes,
  DateOfBirth,
  DateOfDeath
} from 'components/form/FormComposer'
import {
  MultipleLinkInput,
} from 'components/form/FormOeuvre';
import cn from 'classnames';
import CloseModal from "components/form/CloseModal";
import axios from 'lib/axios'
import 'react-loading-skeleton/dist/skeleton.css'
// import { useAuth } from '@/../hooks/auth'
import Loader from "components/ui/Loader"
import { useCookies } from 'react-cookie'
import {
  genders,
  country
} from "constants/data-filter";
import { PIANO_AUTH_CRED  } from "lib/constants"

export default function EditComposerModal({
  open,
  composerToEdit,
  setOpen
}) {

  const [cookie] = useCookies([PIANO_AUTH_CRED]);

  const selectGender = useRef(null);
  const selectNation = useRef(null);

  // User infos
  // const {user} = useAuth();
  // const router = useRouter();

  const [allCountrie, setAllCountrie] = useState([]),
    [selectedCountrie, setSelectedCountrie] = useState([]),
    [dataComposer, setDataComposer] = useState({});

  // handling state
  const [isLoading, setIsLoading] = useState(false),
    [errors, setErrorsMessage] = useState([]),
    [success, setSuccessMessage] = useState(null),
    [allowed, setAllowed] = useState(false),
    [errorNotAllowed, setErrorNotAllowed] = useState(null),
    [isSubmitted, setIsSubmitted] = useState(false);

  const [showHelpLink, setShowHelpLink] = useState(false);

  useEffect(() => {

    if (!open) {
      setDataComposer({});
    } else {

      const json = [];

      composerToEdit?.nationality_id?.forEach((res) => {
        let item = { countries: res }
        json.push(item);
      })

      setSelectedCountrie(json);
      setDataComposer(composerToEdit);
    }
  }, [open]);

  const handleNationality = (e) => {
    let dataNat = e;
    let newData = [];

    dataNat.forEach((res) => (
      newData.push(res.countries)
    ))
    console.log("dataNat", e)
    setDataComposer({ ...dataComposer, nationality_id: newData })
  }

  // Submit cmposers form
  const submitFormComposer = () => {

    setIsSubmitted(true);

    setErrorsMessage([]);

    setSuccessMessage(null);

    setIsLoading(true);

    let newComposer = { ...dataComposer, composer_id: dataComposer?.id }

    axios.post(`/submitting-composers`, newComposer, {
      headers: { 'Authorization': `Bearer ${cookie.auth_piano}` }
    }).then(res => {
      if (res.status === 200) {
        setIsSubmitted(false);
        setIsLoading(false);
        setSuccessMessage("Created successfuly. You will be redirecting in your account")
        setTimeout(() => {
          setOpen(false);
          setSuccessMessage(null);
        }, 3000);
      }
    }).catch((err) => {
      setIsLoading(false);
      console.log("error cpm", err.response);
      setErrorsMessage(Object.values(err.response.data.errors).flat());
    })
  }

  const addNewWebSiteLink = (event) => {
    if (event.key === "Enter" && event.target.value !== "") {
      // if (dataComposer.webSiteLink == null) {
      //   setDataComposer({ ...dataComposer, webSiteLink: [] });
      // }
      setDataComposer({ ...dataComposer, webSiteLink: [...dataComposer.webSiteLink, event.target.value] });
      event.target.value = "";
    }
  };

  const cancelButtonRef = useRef();

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-50 inset-0 overflow-y-auto"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <div className="flex items-start justify-start h-screen">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="
              inline-block align-bottom
              overflow-hidden shadow-xl 
              transform transition-all 
              h-full w-full"
            >
              <div className="h-full w-full bg-gray-100 overflow-y-auto pb-16">
                <CloseModal onClick={() => setOpen(false)} />

                <div className="flex flex-col justify-center items-center py-4">
                  <h2 className="mb-2 text-3xl text-center font-bold text-gray-800">Edit this composer </h2>
                  <p className="text-gray-600">Propose a modification of this composer</p>
                </div>


                <div className="w-full px-4 md:px-8 lg:px-20 xl:px-40 mb-24">

                  <i className="block flex flex-col items-start text-xs text-red-500"> The fields with * are required </i>
                  <div className="rounded bg-white shadow-xl p-8 space-y-6 mt-6">

                    {errorNotAllowed && <p className="text-center text-md text-red-500">{errorNotAllowed} </p>}

                    <LastName
                      value={dataComposer.lastName}
                      onChange={(e) => setDataComposer({ ...dataComposer, lastName: e.target.value })}
                      isSubmitted={isSubmitted}
                      isRequired={true}
                      readOnly={allowed}
                    />

                    <FirstName
                      value={dataComposer.firstName}
                      onChange={(e) => setDataComposer({ ...dataComposer, firstName: e.target.value })}
                      isSubmitted={isSubmitted}
                      isRequired={true}
                      readOnly={allowed}

                    />

                    <DateOfBirth
                      value={dataComposer.dateOfBirth}
                      onChange={(e) => setDataComposer({ ...dataComposer, dateOfBirth: e.target.value })}
                      isSubmitted={isSubmitted}
                      isRequired={true}
                      readOnly={allowed}

                    />

                    <DateOfDeath
                      value={dataComposer.dateOfDeath}
                      onChange={(e) => setDataComposer({ ...dataComposer, dateOfDeath: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    <Gender
                      value={dataComposer.gender}
                      options={genders}
                      myRef={selectGender}
                      defaultValue={dataComposer?.gender}
                      onChange={(e) => setDataComposer({ ...dataComposer, gender: e?.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    {/* Link to score */}
                    <MultipleLinkInput
                      fieldName={"WebSite Link"}
                      onClick={() => setShowHelpLink(!showHelpLink)}
                      showHelpLink={showHelpLink}
                      showHelp={true}
                      showAlert={true}
                      onKeyUp={event => event.key === "Enter" ? addNewWebSiteLink(event) : null}
                      isSubmitted={isSubmitted}
                    >
                      {Array.isArray(dataComposer?.webSiteLink) && dataComposer.webSiteLink.map((item, index) => (
                        <li key={index} className="tag">
                          <span className='tag-title'>{item}</span>
                          <span className='tag-close-icon'
                            onClick={() => setDataComposer({
                              ...dataComposer,
                              webSiteLink: [...dataComposer.webSiteLink.filter(link => dataComposer.webSiteLink.indexOf(link) !== index)]
                            })
                            }
                          >x</span>
                        </li>
                      ))}
                    </MultipleLinkInput>

                    <Nationality
                      value={dataComposer.nationality_id}
                      myRef={selectNation}
                      options={country}
                      defaultValue={selectedCountrie}
                      onChange={(e) => handleNationality(e)}
                      isSubmitted={isSubmitted}
                      isRequired={true}
                      readOnly={allowed}
                    />

                    <Notes
                      value={dataComposer.notes}
                      onChange={(e) => setDataComposer({ ...dataComposer, notes: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    <ErrorMessage errors={errors} />
                    <SuccessMessage success={success} handleHideMsg={() => setSuccessMessage('')} />

                    {/* Action */}
                    <div className="flex flex-col py-4 items-end">
                      <Button
                        disabled={isLoading || allowed}
                        onClick={() => submitFormComposer()}
                        className={cn(
                          !isLoading ? '' : 'bg-gray-500 opacity-50 cursor-not-allowed',
                          ""
                        )}
                      >
                        {!isLoading ? 'Update' :
                          <> <Loader /> <span className="mr-1"></span> Updating... </>
                        }
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
